<template>
    <div
        class="control mx-1 d-flex justify-content-center my-4 flex-wrap"
    >
        <label
            v-for="(option, i) in buttonSatisfactionGradeBuilder"
            :key="option.idButton"
            class="item-option-satisfaction-grade mx-1 cursor-pointer"
            :style="[
                { backgroundColor : `#${option.color}` },
                hoverAnimation(`#${option.color}91`, option.idButton),
                answer === option.idButton ? onSelected(`#${option.color}91`) : ''
            ]"
            @mouseover="onMouseOver(option.idButton)"
            @mouseleave="onMouseLeave()"
        >
            <input
                data-vv-name="option"
                v-validate="'required'"
                type="radio"
                class="custom-control-input"   
                :id="option.idButton" 
                :name="`option-${option.name}`"
                :value="option.idButton"
                v-model="answer"
            /> 
            <div class="text-white">{{ i }}</div>
        </label>
    </div>
</template>

<script>

import { generateSpectrumTricolor } from "../../../utils/ColorSequence";
import hoverEffect from "../../../mixins/hoverEffect";

export default {
    emits: ['input', 'update:modelValue'],
    name: "TopicSatisfactionGrade",
    mixins: [hoverEffect],

    props:{
        topic:{
            type: Object,
            required: true
        },
        modelValue:{
            type: String | Number
        }
    },

    computed:{
        answer:{
            get(){
                return this.modelValue;
            },
            set(answer){
                this.$emit('update:modelValue', answer);
                this.$emit('input', answer);
            }
        },

        buttonSatisfactionGradeBuilder(){
            const listColors = generateSpectrumTricolor('#B71C1C', '#FB8C00', '#00C853', this.topic.options.length);
            const listButtons = listColors.map((color, index) => {
                const idButton = this.topic.options[index].id;
                return { idButton, color };
            });
            return listButtons;
        }
    }
}
</script>
<style scoped>
.item-option-satisfaction-grade{
    border-radius: 10px;
    width: 50px;
    height: 50px;

    display: flex;
    align-items: center;
    justify-content: center;
}
</style>